import { useTranslation } from 'react-i18next';
import React from 'react';
import { CloudOff } from 'lucide-react';

/**
 * Shared "you're working offline" strip for document lists. Shown when
 * the browser has no connection, or when a list is being served from
 * the on-device cache because the fetch didn't get through.
 */
export const OfflineNotice = ({ isOnline, cached, what = 'documents', testId = 'offline-notice' }) => {
  const { t } = useTranslation();
  if (isOnline && !cached) return null;
  return (
    <div
      className="flex items-start gap-2 rounded-lg border border-slate-300 bg-slate-50 p-2.5 text-sm text-slate-700"
      data-testid={testId}
    >
      <CloudOff className="h-4 w-4 shrink-0 mt-0.5" />
      <div>
        <strong>{isOnline ? t('auto.misc2.showingTheCopyOnThisDevice') : t('auto.misc2.workingOffline')}</strong>
        <div className="text-xs mt-0.5 opacity-80">
          {`You're seeing the ${what} saved on this device. New ones and any edits you make are kept here and upload by themselves as soon as you have signal.`}
        </div>
      </div>
    </div>
  );
};

/** Small "waiting to upload" pill for a document created offline. */
export const PendingSyncBadge = ({ testId = 'pending-sync-badge', label = 'Not uploaded yet' }) => (
  <span
    className="inline-flex items-center gap-1 rounded-full border border-slate-300 bg-slate-100 px-1.5 py-0.5 text-[10px] font-medium text-slate-600"
    data-testid={testId}
  >
    <CloudOff className="h-3 w-3" /> {label}
  </span>
);

export default OfflineNotice;
